export function track() {
  if (typeof window === 'undefined') return;
  var params = arguments;
  console.log(params);
  setTimeout(() => analytics.track.apply(this, params), 1);
}

export function trackNow() {
  if (typeof window === 'undefined') return;
  console.log(arguments);
  analytics.track.apply(this, arguments);
}

export function trackPage() {
  if (typeof window === 'undefined') return;
  analytics.page.apply(this, arguments);
}



// WEBPACK FOOTER //
// ./shared/models/analytic.js